export enum Language {
	ES = 'ES',
	EN = 'EN',
}
